<template>
  <div>
    <headline :content="$t('project.document_template')">
      <div class="d-block w-100">
        <div class="d-flex justify-end mb-2">
          <v-btn elevation="1" right color="success" @click="isEditorDialog = true">
            <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('project.add_document_template') }}
          </v-btn>
        </div>
      </div>
    </headline>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div v-if="!isLoading">
          <v-card v-for="contractTemplate in contractTemplates" :key="contractTemplate.objectId" class="my-3">
            <v-list-item three-line>
              <v-list-item-avatar tile size="120">
                <v-icon x-large>mdi-text-box-multiple-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <h2>
                  <b>
                    {{ contractTemplate.title }}
                    <v-icon @click="saveTemplateTitleDialog(contractTemplate)">mdi-pencil</v-icon>
                  </b>
                </h2>
                <p style="font-weight: 300;font-size: 14px;">
                  <b>{{ $t('project.last_edited') }} :</b>
                  {{ $moment(contractTemplate.updatedAt).format("DD/MM/YYYY HH.mm") }}{{ $t('timeunit.minute.short') }}
                </p>
              </v-list-item-content>
              <v-list-item-avatar tile size="120" class="text-end" width="200">
                <v-card elevation="0">
                  <v-btn @click="editContractTemplate(contractTemplate)" class="my-1" color="warning" outlined>
                    <v-icon class="mr-1">mdi-pencil</v-icon>{{ $t('project.edit_detail') }}
                  </v-btn>
                  <v-btn @click="confirmDialogRemove(contractTemplate)" class="my-1" color="error" outlined>
                    <v-icon class="mr-1">mdi-trash-can-outline</v-icon>{{ $t('action_type.delete') }}
                  </v-btn>
                </v-card>
              </v-list-item-avatar>
            </v-list-item>
          </v-card>
        </div>
        <v-card class="d-flex justify-center py-10" elevation="0" v-else>
          <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
        </v-card>
      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <v-snackbar v-model="isDelSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('delete_success') }}
    </v-snackbar>
    <ConfirmDialog v-if="isConfirmDialogRemove" v-model="isConfirmDialogRemove" type="error"
      :title="$t('validate.want_delete_document_template', { title: tempContractTemplate.title })" @onOk="removeContractTemplate()" />
    <DocumentEditorDialog v-if="isEditorDialog" :title="tempContractTemplate ? tempContractTemplate.title : null"
      :layout="tempContractTemplate ? tempContractTemplate.layout : null"
      :paperSetting="tempContractTemplate ? tempContractTemplate.paperSetting : null" :projectId="projectId"
      type="template" @onClose="onEditorClose" @onSave="onEditorData" />
    <v-dialog v-model="isSaveTemplateTitleDialog" max-width="500" scrollable>
      <v-form @submit.prevent="saveTemplateTitle()" ref="form" :lazy-validation="true">
        <v-card style="font-family: 'Prompt' !important">
          <v-card-title style="font-family: 'Prompt' !important">
            <h2>{{ $t('project.edit_document_template_title') }}</h2>
          </v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-card-text class="py-0">
            <span>{{ $t('project.document_template_title') }}</span>
            <v-text-field v-model="tempTemplateTitle" flat background-color="grey lighten-4" solo :label="$t('project.document_template_title')"
              :rules="[rules.required]"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="error" @click="isSaveTemplateTitleDialog = false">{{ $t('cancel') }}</v-btn>
            <v-btn class="success" type="submit" :disabled="isLoading">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import Layout from "../../components/Layout";
import Headline from "../../components/Headline";
import { mapState } from "vuex";
import ConfirmDialog from "../../components/ConfirmDialog.component.vue";
import DocumentEditorDialog from "../../components/DocumentEditorDialog.component.vue";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
export default {
  data() {
    return {
      isLoading: false,
      projectId: this.$route.params.projectId,
      isError: false,
      isSuccess: false,
      isEditorDialog: false,
      tempContractTemplate: null,
      isConfirmDialogRemove: false,
      isDelSuccess: false,
      isSaveTemplateTitleDialog: false,
      tempTemplateTitle: null,
      rules: {
        required: value => !!value || this.$t('validate.please_input_data')
      }
    };
  },
  computed: {
    ...mapState({
      sessionAdmins: state => state.admin.sessionAdmins,
      contractTemplates: state => state.contractTemplate.contractTemplates
    }),
    admin() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    }
  },
  components: {
    Layout,
    Headline,
    ConfirmDialog,
    DocumentEditorDialog,
    VueCropper
  },
  async created() {
    this.isLoading = true;
    try {
      this.isLoading = false;
      await this.$store.dispatch(
        "contractTemplate/getContractTemplates",
        this.projectId
      );
    } catch (error) {
      this.isError = true;
      this.isLoading = false;
    }
  },
  methods: {
    onEditorClose() {
      this.tempContractTemplate = null;
      this.isEditorDialog = false;
    },
    async onEditorData(data) {
      this.isLoading = true;
      try {
        let formData = {
          projectId: this.projectId,
          layout: data.layout,
          title: data.title,
          paperSetting: data.paperSetting
        };
        if (this.tempContractTemplate) {
          formData.id = this.tempContractTemplate.objectId;
          await this.$store.dispatch(
            "contractTemplate/editContractTemplate",
            formData
          );
        } else {
          await this.$store.dispatch(
            "contractTemplate/createContractTemplate",
            formData
          );
        }
        this.isSuccess = true;
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    editContractTemplate(contractTemplate) {
      this.tempContractTemplate = contractTemplate;
      this.isEditorDialog = true;
      window.scrollTo(0, 0)
    },
    confirmDialogRemove(contractTemplate) {
      this.tempContractTemplate = contractTemplate;
      this.isConfirmDialogRemove = true;
    },
    async removeContractTemplate() {
      this.isLoading = true;
      try {
        await this.$store.dispatch(
          "contractTemplate/removeContractTemplate",
          this.tempContractTemplate.objectId
        );
        this.isDelSuccess = true;
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    saveTemplateTitleDialog(contractTemplate) {
      this.tempContractTemplate = contractTemplate;
      this.tempTemplateTitle = contractTemplate.title;
      this.isSaveTemplateTitleDialog = true;
    },
    async saveTemplateTitle() {
      this.isLoading = true;
      this.isSaveTemplateTitleDialog = false;
      try {
        let formData = {
          id: this.tempContractTemplate.objectId,
          title: this.tempTemplateTitle
        };
        await this.$store.dispatch(
          "contractTemplate/editContractTemplate",
          formData
        );
        this.isSuccess = true;
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.link-variant {
  position: absolute;
  display: inline;
  top: 8px;
  right: -45px;
}
</style>